import React from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, change as changeFieldValue } from 'redux-form';
import { TextField, SelectField } from '../fields';
import { required, normalizePostcode, validPostcode } from '../../utilities/validation';
import messages from '../../text/messages';
import options from '../../text/selectOptions';
import { bindActionCreators } from 'redux';

class AddressComponent extends React.Component {
    constructor(props) {
        super(props);

        this.getStateOptions = this.getStateOptions.bind(this);
        this.getPostcodeFieldName = this.getPostcodeFieldName.bind(this);
        this.getStateField = this.getStateField.bind(this);
        this.postValidator = this.postValidator.bind(this);
    }

    getStateOptions() {
        const { country } = this.props.formValues || {};
        return options.countryStates[country] || [];
    }

    getPostcodeFieldName() {
        const { country } = this.props.formValues && this.props.formValues.country ? this.props.formValues : { country: 'US' };
        return options.countryPostcodeFieldName[country];
    }

    postValidator(value) {
        const { country } = (this.props && this.props.formValues) || {};

        return validPostcode(country, value);
    }

    getPostNormalizer(country) {
        return value => normalizePostcode(country, value);
    }

    getStateField() {
        const { changeFieldValue, formValues, form, section, disabledFields = [], disabled } = this.props;
        const { country, state } = formValues && formValues.country ? formValues : { country: 'US' };
        const stateOrProvince = options.countryStateFieldName[country];
        if (!stateOrProvince) {
            if (state) {
                changeFieldValue(form, section ? `${section}.state` : 'state', '');
            }
        }
        return (
            <div className="col-xs-6 col-sm-3">
                <Field
                    name="state"
                    component={country === 'UK' ? TextField : SelectField}
                    options={this.getStateOptions()}
                    placeholder={stateOrProvince}
                    disabled={disabled || disabledFields.includes('state')}
                />
            </div>
        );
    }
    render() {
        const { countriesOptions, hideName, oneLineAddress, disabledFields = [], disabled, formValues } = this.props;
        const { country } = formValues || { country: 'US' };

        return (
            <div className="row">
                <div className="address-fields col-xs-12">
                    {!hideName && (
                        <div className="col-xs-12">
                            <Field
                                name="name"
                                component={TextField}
                                validate={required}
                                placeholder={messages.addressName}
                                disabled={disabled || disabledFields.includes('name')}
                            />
                        </div>
                    )}
                    <div className="col-xs-12 col-sm-6">
                        <Field
                            name="country"
                            component={SelectField}
                            options={countriesOptions}
                            validate={required}
                            placeholder={messages.country}
                            disabled={disabled || disabledFields.includes('country')}
                        />
                    </div>
                    <div className="col-xs-12" />
                    <div className={`col-xs-12  col-sm-${oneLineAddress ? 6 : 12}`}>
                        <Field
                            name="street"
                            component={TextField}
                            validate={required}
                            placeholder={messages.address}
                            disabled={disabled || disabledFields.includes('street')}
                        />
                    </div>
                    <div className={`col-xs-12  col-sm-${oneLineAddress ? 6 : 12}`}>
                        <Field
                            name="street2"
                            component={TextField}
                            placeholder={messages.addressSecondary}
                            disabled={disabled || disabledFields.includes('street2')}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <Field
                            name="city"
                            component={TextField}
                            validate={required}
                            placeholder={messages.city}
                            disabled={disabled || disabledFields.includes('city')}
                        />
                    </div>

                    {this.getStateField()}

                    <div className="col-xs-6 col-sm-3">
                        <Field
                            name="zip"
                            component={TextField}
                            validate={this.postValidator}
                            normalize={this.getPostNormalizer(country)}
                            placeholder={this.getPostcodeFieldName()}
                            disabled={disabled || disabledFields.includes('zip')}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ changeFieldValue }, dispatch);
}

const mapStateToProps = (state, props) => {
    const formValues = getFormValues(props.form)(state) || {};
    const countriesOptions = Object.entries(props.countries || state.identity.details.countries || {}).reduce((a, [key, value]) => {
        if (value === 'active') {
            a.push({ value: key, label: key });
        }
        return a;
    }, []);

    return {
        countriesOptions,
        formValues: props.section ? formValues[props.section] : formValues
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressComponent);



// WEBPACK FOOTER //
// ./src/components/address/index.jsx